import React, {
  DetailedHTMLProps,
  FieldsetHTMLAttributes,
  forwardRef,
} from 'react';

export type SectionFieldsetProps = DetailedHTMLProps<
  FieldsetHTMLAttributes<HTMLFieldSetElement>,
  HTMLFieldSetElement
> & {
  legend: string;
};

export const SectionFieldset = forwardRef<
  HTMLFieldSetElement,
  SectionFieldsetProps
>(({ legend, children, ...props }, ref) => {
  return (
    <fieldset {...props} ref={ref} className="m-0 box-border border-none p-0">
      <legend className="rs-font text-16 text-gray-1000 pc:text-15 mb-1.5 block font-bold">
        {legend}
      </legend>
      <div>{children}</div>
    </fieldset>
  );
});

SectionFieldset.displayName = 'SectionFieldset';
